export default "__VITE_ASSET__CrwDB_8F__"